import { createReactBlockSpec } from "@blocknote/react";

const TYPE = "customblocktype"; // Change this for your block type

export const CustomBlock = createReactBlockSpec(
    {
        type: TYPE,
        propSchema: {
            data: {
                default: "default value",
            },
        },
        content: "inline", // or "inline" if you want formatted text
    },
    {
        render: ({ block, editor }) => {
            const { data } = block?.props;

            // Handle changes to your block's data
            const onDataChange = (newValue: any) => {
                editor.updateBlock(block, {
                    props: {
                        ...block.props,
                        data: newValue,
                    },
                });
            };

            // Return your custom component here
            return (
                <div className="custom-block">
                    {/* Your custom UI components */}
                </div>
            );
        },

        // Define how your block should be exported to HTML
        toExternalHTML: ({ block }) => {
            return (
                <div className="custom-block-html">
                    {/* Your HTML structure */}
                    {block?.props?.data}
                </div>
            );
        },
    }
);
